module.exports = __webpack_public_path__ + "img/etax-inet.0e96772.webp";